"use client";

import { Group, Image, Paper, Text, Loader, Tooltip, Box as MantineBox } from "@mantine/core";
import { useImageSearchStore } from "@/stores/imageSearchStore";
import styles from "./styles.module.scss";

const ImageSearchBanner: React.FC = () => {
  const sourceItem = useImageSearchStore((state) => state.sourceItem);
  const loading = useImageSearchStore((state) => state.loading);
  const total = useImageSearchStore((state) => state.total);
  const items = useImageSearchStore((state) => state.items);
  const { requestRecrop } = useImageSearchStore((state) => state.actions);

  const count = total ?? items.length;
  const displayCount = (total ?? 0) >= 500 ? "500+" : count;

  return (
    <Paper classNames={{ root: styles.imageSearchBanner }} p="8px" withBorder>
      <Group justify="flex-end" align="center">
        <Group gap="md">
          {sourceItem?.imageurl && (
            <Tooltip label="Adjust crop" position="bottom" withArrow>
              <Image
                src={sourceItem.imageurl}
                alt="Search source"
                w={60}
                h={60}
                fit="cover"
                radius="sm"
                style={{ cursor: "pointer" }}
                onClick={requestRecrop}
              />
            </Tooltip>
          )}
          <MantineBox>
            <Text size="sm" fw={600}>
              Finding similar items
            </Text>
            <Text size="xs" c="dimmed">
              {loading ? "Searching..." : `${displayCount} similar items found`}
            </Text>
          </MantineBox>
          {loading && <Loader size="sm" />}
        </Group>
      </Group>
    </Paper>
  );
};

export default ImageSearchBanner;
